module.exports = __webpack_public_path__ + "static/media/round-done-button.9148d889.svg";